import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface ScatterChartProps {
  points: Array<[number, number, string?]>;
  height?: number | string;
  loading?: boolean;
}

export function ScatterChart({ points, height, loading }: ScatterChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'item' },
    grid: { left: 40, right: 20, top: 20, bottom: 40, containLabel: true },
    xAxis: { type: 'value' },
    yAxis: { type: 'value' },
    series: [{ type: 'scatter', data: points }],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
